import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const PILOT_URL =
  "https://calendly.com/wsafeai-info/worksafeagent-pilot-20-min-fit-call";
export const MOBILE_ACCESS_URL = "https://wsafe.si";
export const SIGN_IN_URL = "https://wsafeai.com/login";

const NAV_ITEMS = [
  { label: "How it works", hash: "#how-it-works" },
  { label: "Products", hash: "#products" },
  { label: "Pricing", hash: "#pricing" },
  { label: "Partners", hash: "#partners" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const prefix = pathname === "/" ? "" : "/";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3 md:px-10">
        <Link to="/" data-testid="header-logo-link" aria-label="WSafe AI Mobile home">
          <img
            src="/wsafe-ai-lockup-light.svg"
            alt="WSafe AI"
            className="h-9 w-auto"
            data-testid="header-logo"
          />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" data-testid="header-nav">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.hash}
              href={`${prefix}${item.hash}`}
              data-testid={`nav-${item.hash.slice(1)}-link`}
              className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-navy"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={SIGN_IN_URL}
            data-testid="header-sign-in-button"
            className="rounded-full px-4 py-2 text-sm font-semibold text-navy transition-colors duration-200 hover:bg-slate-100"
          >
            Sign in
          </a>
          <a
            href={PILOT_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-pilot-button"
            className="rounded-full bg-safety px-5 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-safety-dark"
          >
            Request the $1,000 founding paid pilot
          </a>
        </div>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label="Toggle navigation menu"
          onClick={() => setOpen(!open)}
          className="rounded-md p-2 text-navy hover:bg-slate-100 lg:hidden"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="border-t border-slate-200 bg-white px-6 py-4 lg:hidden"
        >
          <div className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.hash}
                href={`${prefix}${item.hash}`}
                data-testid={`mobile-nav-${item.hash.slice(1)}-link`}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href={SIGN_IN_URL}
              data-testid="mobile-sign-in-button"
              className="rounded-md px-3 py-2 text-sm font-semibold text-navy hover:bg-slate-100"
            >
              Sign in
            </a>
            <a
              href={PILOT_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-pilot-button"
              className="mt-2 rounded-full bg-safety px-5 py-2.5 text-center text-sm font-semibold text-white hover:bg-safety-dark"
            >
              Request the $1,000 founding paid pilot
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
